const actionlocation = 'footer-module';

export const MODULE_VIEW_EVENT_OPTIONS = {
  actionlocation
};



// WEBPACK FOOTER //
// ./src/universal/components/Footer/events.js